// Panda (V2) chat UI constants, shared across web and mobile. Wire-protocol
// constants live in ag-ui.constants.ts.

// Thumbs selection on an answer. UI state only — feedback is reported via
// analytics events and never persisted (unlike v1's zeus FEEDBACK_TYPE).
export const FEEDBACK_VALUE = {
  POSITIVE: 'positive',
  NEGATIVE: 'negative',
} as const;

/** Current thumbs selection; `null` = nothing selected. */
export type FeedbackValue = (typeof FEEDBACK_VALUE)[keyof typeof FEEDBACK_VALUE] | null;

/** Analytics `result_type` — deliberately not in SEARCH_TYPES_KEYS: the card is not a results bucket, tab, or renderer key. */
export const PANDA_SEARCH_RESULT_TYPE = 'Panda AI';
